module.exports = __webpack_public_path__ + "img/3.fc68c2ec.png";